var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"border":"none"},attrs:{"src":"/codigo/tramites/pendientes.php","allow":"camera *; geolocation *; microphone *; autoplay *","frame-id":"my-ifram","name":"my-frame","width":"100%","height":"700px"}})}
var staticRenderFns = []

export { render, staticRenderFns }